import { createQueriesConfig } from '@wix/premium-fed-sdk/apis-infra';
import { getRegistrationDateQueryFn } from './queryFn/getRegistrationDate.query';
export const UserProfileQueriesConfig = createQueriesConfig({
  getRegistrationDate: {
    queryFn: getRegistrationDateQueryFn
  }
});
//# sourceMappingURL=userProfile.queries.js.map